import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import Navbar from './Navbar'
import { authenticateGetDetail,checkPerTonne, checkFreqLanes, checkPerKg  } from '../service/api'
import "./LandingPage.css"
import { NavLink } from 'react-router-dom'
import Footer from './Footer'
import truck from "../images/truck2.png"
import Popup from './Popup';
import LiveRfqs from "./LiveRfqs"
import { getDownloadURL, listAll, ref, uploadBytesResumable } from '@firebase/storage';
import { Helmet } from 'react-helmet';
import { GrDownload, GrRefresh } from 'react-icons/gr';
import { FaFileDownload } from 'react-icons/fa';
import {  GoArrowRight } from 'react-icons/go';
import LoadingScreen from './LoadingScreen';
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import { LoginContext } from "../Contexts/ContextProvider";
import { useContext } from 'react'
import { bringInData,sendInData } from '../service/api'
import { bringInDataPerTon,sendInDataPerTon } from '../service/api'
import { bringInDataFreqLanes,sendInDataFreqLanes } from '../service/api'
import ProfileProgress from './ProfileProgress';
import { useHistory } from 'react-router-dom';
import image_32 from '../images/image_32.png'
import image_33 from '../images/image_33.png'
import { data } from './Data';

function LandingPage() {

        const [loading,setLoading]=useState(true);
        const [posts,setPosts]=useState({});
        const [isOpenKg,setIsopenKg]=useState(false);
        const [isOpenTonne,setIsopenTonne]=useState(false);
        const [isOpenLanes,setIsopenLanes]=useState(false);
        const [progress,setProgress]=useState(0);
        const [uploadPc,setUploadPc]=useState("none");
        const [lastFileKg,setLastFileKg]=useState("");
        const [lastFileUrlKg,setLastFileUrlKg]=useState("");
        const [lastFileTn,setLastFileTn]=useState("");
        const [lastFileUrlTn,setLastFileUrlTn]=useState("");
        const [lastFileLanes,setLastFileLanes]=useState("");
        const [lastFileUrlLanes,setLastFileUrlLanes]=useState("");
        const {userEmail,account,setAccount,setUserEmail}=useContext(LoginContext);
        const [isOpenRfqs,setIsOpenRfqs]=useState(false);
        const [presentPerKg,setPresentPerKg]=useState(false);
        const [presentPerTonne,setPresentPerTonne]=useState(false);
        const [presentFreqlanes,setPresentFreqLanes]=useState(false);
        const [percentage,setPercentage]=useState(25);
        const [openSnackBar,setOpenSnackBar]=useState(false);
        const [severity,setSeverity]=useState("");
        const [msg,setMsg]=useState("");
        const [finalPercentage,setFinalPercentage]=useState(0);
        const [isOpenProgress,setIsOpenProgress]=useState(false);
        const [dispOther,setDispOther]=useState('none');
        const [diffInDays,setDiffInDays]=useState(0);
        const [dispPerKg,setDispPerKg]=useState('block');
        const [dispPerTon,setDispPerTon]=useState('block');
        const [dispPerKgLast,setDispPerKgLast]=useState('none');
        const [dispPerTonLast,setDispPerTonLast]=useState('none');
        const [dispPerFreq,setDispPerFreq]=useState('block');
        const [profile,setProfile]=useState('');
        const [frequentLanes,setFrequentLanes]=useState([{
            from:"",
            to:"",
            type:""
        }])
        const [filteredSuggestions, setFilteredSuggestions] = useState([]);
        const [activeSuggestionIndex, setActiveSuggestionIndex] = useState(0);
        const [showSuggestionsF, setShowSuggestionsF] = useState([]);
        const [showSuggestionsT, setShowSuggestionsT] = useState([]);
        const [input, setInput] = useState("");
        const history=useHistory();
       
    useEffect(() => {
            try{
                authenticateGetDetail().then((response)=>{setAccount(response.data)
                setUserEmail(response.data.Email)
                setPosts(response.data)
                const date1=new Date(response.data.registerDate)
                const date2=new Date(response.data.loginDate)
                const timing=Math.floor(Difference_In_Time / (1000 * 3600 * 24))
                if(timing>180){
                    document.getElementById("platinumMem").innerHTML="Regular";
                    document.getElementById("180Validation").innerHTML="Expired";
                }
                var Difference_In_Time = date2.getTime() - date1.getTime();
                setDiffInDays(Math.floor(Difference_In_Time / (1000 * 3600 * 24)))
            if(response.data.trucks && response.data.Revenue && response.data.Exp_Companies && response.data.Sector && response.data.Service){
                setDispOther('none');
            }
            else{
                setDispOther('block');
            }
        })
                setLoading(false);
            }
            catch(err){
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg(err);
            }
        
    }, [ ,sendInData,sendInDataFreqLanes,sendInDataPerTon])


    useEffect(()=>{
        ProgressPercentage()
    },[posts,presentPerKg,presentPerTonne,presentFreqlanes])
    

    useEffect(()=>{
        console.log(userEmail);
        checkPerKg({email:userEmail}).then((response)=>{if(response){setPresentPerKg(true)
        setDispPerKg('none')
        setDispPerKgLast('block')
    }}).catch(err=>{
        console.log(err);
    })
        checkPerTonne({email:userEmail}).then((response)=>{if(response){setPresentPerTonne(true)
        setDispPerTon('none')
        setDispPerTonLast('block')
    }}).catch(err=>{
            console.log(err);
        })
        checkFreqLanes({email:userEmail}).then((response)=>{if(response){setPresentFreqLanes(true)
        setDispPerFreq('none')
        setFrequentLanes(response.data.fileAoO);
        let data=[];   
        for(let i=0;i<response.data.fileAoO.length;i++){
            data.push(false);
        }
        setShowSuggestionsF(data);
        setShowSuggestionsT(data);
    }}).catch(err=>{
            console.log(err);
        })
    },[userEmail,profile])

    useEffect(()=>{
        checkFreqLanes({email:userEmail}).then((response)=>{if(response){
            setFrequentLanes(response.data.fileAoO); 
            let data=[];   
            for(let i=0;i<response.data.fileAoO.length;i++){
                data.push(false);
            }
            setShowSuggestionsF(data);
            setShowSuggestionsT(data);
        }}).catch(err=>{
            console.log(err);
        })
    },[isOpenLanes])

    useEffect(()=>{
        console.log(percentage);
        (percentage<100)?setIsOpenProgress(true):setIsOpenProgress(false);
    },[percentage])
    function ProgressPercentage(){
        setPercentage(25);
        console.log(Object.keys(posts).length !== 0)
        if(Object.keys(posts).length !== 0){
          if(posts.trucks.length>0){
              setPercentage(prevItem=>prevItem+5)
              console.log(posts.trucks)
              console.log("trucks")
          }
          if(posts.Revenue!=="0"){
              setPercentage(prevItem=>prevItem+5)
              console.log(posts.Revenue)
              console.log("rev")
          }
          
          if(posts.Exp_Companies){
              setPercentage(prevItem=>prevItem+5)
              console.log(posts.Exp_Companies)
              console.log("exp")
          }
          
          if(posts.Sector.length>0){
              setPercentage(prevItem=>prevItem+5)
              console.log(posts.Sector)
              console.log("sec")
          }
          
          if(posts.Service){
              setPercentage(prevItem=>prevItem+5)
              console.log(posts.Service)
              console.log("ser")
          }
          
          // if(presentPerKg || presentPerTonne){
          //     setPercentage(prevItem=>prevItem+25)
          //     console.log("perkg")
          // }
          if(presentFreqlanes){
              setPercentage(prevItem=>prevItem+50)
              console.log(frequentLanes)
              console.log("freq")
          }
        }
        return percentage;
      }

    //kg start
    function formHandlerKg(e){
        e.preventDefault();
        const file=e.target[0].files[0];
        console.log(file);
        var fileInput = 
        document.getElementById('file-inp-kg');
        var filePath = fileInput.value;
         //Allowing file type
         var allowedExtensions = 
         /(\.xlsx)$/i;
   
 if (!allowedExtensions.exec(filePath)) {
     alert('No file found or Invalid File Format (.xlsx only allowed)');
   
 }
   else
   {
    // alert("file uploaded")
        
              fileHandlerKg(file);
              setUploadPc("block");
        // fetchFiles();
   }
    }
    
     const fileHandlerKg = async(file)=>{
          if(!file) return;
          const d=new Date();
         console.log(file);
         var time = d.getTime();
         var day = d.getDate();
         var month = d.getMonth();
         var yr = d.getFullYear();
         const filetime=time+""+day+""+month+""+yr;

         // Math.round(new Date().getTime()/1000)
         const data=new FormData();
         data.append('file',file);
         data.append('email',userEmail);
         console.log(data);
         const response=await sendInData(data).then((response)=>{
            if(response.data){
                console.log("Success");
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("success");
                setMsg("Saved File");
                setProfile(filetime);
                console.log(response);
            }
            else{
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg("Bad Request");
            }
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })     
    };

    async function fetchFilesKg(){
        const response=await bringInData({email:userEmail}).then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportData.xlsx');
            document.body.appendChild(link);
            link.click();
             
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
         console.log(response);
    }
    
    //kg End

    //Tonne Start
    function formHandlerTonne(e){
        e.preventDefault();
        const file=e.target[0].files[0];
        console.log("uploaded file",file)

        var fileInput = 
        document.getElementById('file-inp-tonne');
        var filePath = fileInput.value;

         // Allowing file type
         var allowedExtensions = 
         /(\.xlsx)$/i;



   
 if (!allowedExtensions.exec(filePath)) {
     alert('No file found or Invalid File Format (.xlsx only allowed)');
   
 }
   else
   {
    // alert("file uploaded")
      
      fileHandlerTonne(file);
        setUploadPc("block");
        // fetchFiles();
  
     
   }
    }
    
     const fileHandlerTonne = async(file)=>{
         console.log(file);
        if(!file) return;


         // Math.round(new Date().getTime()/1000)
         const d=new Date();
         
         var time = d.getTime();
         var day = d.getDate();
         var month = d.getMonth();
         var yr = d.getFullYear();
         const filetime=time+""+day+""+month+""+yr;
        const data=new FormData();
         data.append('file',file);
        data.append('email',userEmail);
        await sendInDataPerTon(data).then((response)=>{
            if(response.data){
                console.log("Success");
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("success");
                setMsg("Saved File");
                setProfile(filetime);
                console.log(response);
            }
            else{
                setIsopenTonne(false);
                setUploadPc('none');
                setOpenSnackBar(true);
                setSeverity("error");
                setMsg("Bad Request");
            }
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })
        
           
    };

     async function fetchFilesTonne(){
        console.log("fetch Tn")
        console.log(userEmail);
        await bringInDataPerTon({email:userEmail}).then((response)=>{
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exportData.xlsx');
            document.body.appendChild(link);
            link.click();
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         });
    }

    //Tonne End

 //Lanes Start
 
async function fileHandlerLanes(){
    const d=new Date();
     var time=d.getTime();
     var day=d.getDate();
     var month=d.getMonth();
     var yr=d.getFullYear();
     const filetime=time+""+day+""+month+""+yr;
     var allFilled=true;
     frequentLanes.map(element=>{
         if(!element.from || !element.to || !element.type){
             console.log(false);
            allFilled=allFilled&&false;
         }
         else{
             console.log(true)
            allFilled=allFilled&&true;
         }
     })
     console.log(allFilled);
     if(allFilled){
    await sendInDataFreqLanes({email:userEmail,fileAoO:frequentLanes}).then(()=>{
        console.log("Success");
            setIsopenLanes(false);
            setUploadPc('none');
            setOpenSnackBar(true);
            setSeverity("success");
            setMsg("Saved File");
            setProfile(filetime);
         }).catch((e)=>{
            setOpenSnackBar(true);
            setSeverity("error");
            setMsg("Error:",e);
         })
     }
     else{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Fill in all the fields before submitting");
     }
}


async function fetchFilesLanes(){
    console.log("fetch Fl")
    const response=await bringInDataFreqLanes({email:userEmail}).then((response)=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'exportData.xlsx');
        document.body.appendChild(link);
        link.click();
     }).catch((e)=>{
        setOpenSnackBar(true);
        setSeverity("error");
        setMsg("Error:",e);
     });
     console.log(response);    

}

//Tonne End

    function Alert(props) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
      }
      const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }

        setOpenSnackBar(false);
      };



    const handleFormChange = (index, event) => {
          console.log(event.target.name);
          console.log(event.target.value);
          let data = [...frequentLanes];
          data[index][event.target.name] = event.target.value;
          setFrequentLanes(data);
    }
    
      const addInput = () => {
        let newfield = { from:"",to:"",type:"" }

        setFrequentLanes([...frequentLanes, newfield])
        setShowSuggestionsT([...showSuggestionsT,false])
        setShowSuggestionsF([...showSuggestionsF,false])
      }
    const minusInput = (index) => {
        const arr1=[...frequentLanes];
        console.log(arr1);
        arr1.splice(index,1);
        console.log(arr1);
        setFrequentLanes(arr1);
        const arr2=[...showSuggestionsF];
        arr2.splice(index,1);
        console.log(arr2);
        setShowSuggestionsF(arr2);
        const arr3=[...showSuggestionsT];
        arr3.splice(index,1);
        setShowSuggestionsT(arr3);
    }

    function checkFreqTable(){
        if(frequentLanes.length<=1){
          return {display:'none'};
        }
        else{
          return {display:'block'}
        }
      }


//Autocomplete


      const onChangeFrom = (e,index) => {
        const userInput = e.target.value;

        // Filter our suggestions that don't contain the user's input
        const unLinked = data.filter(
          (suggestion) =>
            suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        let data2 = [...frequentLanes];
        data2[index][e.target.name] = e.target.value;
        setFrequentLanes(data2);
        setFilteredSuggestions(unLinked);
        setActiveSuggestionIndex(0);
        let data1=[...showSuggestionsF];
        data1[index]=true;
        setShowSuggestionsF(data1);
      };
    const onChangeTo = (e,index) => {
        const userInput = e.target.value;

        // Filter our suggestions that don't contain the user's input
        const unLinked = data.filter(
          (suggestion) =>
            suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1
        );

        let data2 = [...frequentLanes];
        data2[index][e.target.name] = e.target.value;
        setFrequentLanes(data2);
        setFilteredSuggestions(unLinked);
        setActiveSuggestionIndex(0);
        let data1=[...showSuggestionsT];
        data1[index]=true;
        setShowSuggestionsT(data1);
      };

      const onClick= (e,index,targete) => {
        setFilteredSuggestions([]);
        let data2 = [...frequentLanes];
        data2[index][targete] = e.target.innerText;
        setFrequentLanes(data2);
        console.log(e.target.innerText)
        setActiveSuggestionIndex(0);
        let data=[...showSuggestionsT];
        data[index]=false;
        setShowSuggestionsT(data);
        let data1=[...showSuggestionsF];
        data1[index]=false;
        setShowSuggestionsF(data1);
      };

      const onKeyDownFrom = (e,index) => {
        // User pressed the enter key
        if (e.keyCode === 13) {
        let data2 = [...frequentLanes];
        data2[index][e.target.name] = filteredSuggestions[activeSuggestionIndex];
        setFrequentLanes(data2);
          setActiveSuggestionIndex(0);
            let data1=[...showSuggestionsF];
            data1[index]=false;
            setShowSuggestionsF(data1);
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
          if (activeSuggestionIndex === 0) {
            return;
          }

          setActiveSuggestionIndex(activeSuggestionIndex - 1);
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
          if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
            return;
          }

          setActiveSuggestionIndex(activeSuggestionIndex + 1);
        }
      };
    const onKeyDownTo = (e,index) => {
        // User pressed the enter key
        if (e.keyCode === 13) {
        let data2 = [...frequentLanes];
        data2[index][e.target.name] = filteredSuggestions[activeSuggestionIndex];
        setFrequentLanes(data2);
          setActiveSuggestionIndex(0);
            let data=[...showSuggestionsT];
            data[index]=false;
            setShowSuggestionsT(data);
        }
        // User pressed the up arrow
        else if (e.keyCode === 38) {
          if (activeSuggestionIndex === 0) {
            return;
          }

          setActiveSuggestionIndex(activeSuggestionIndex - 1);
        }
        // User pressed the down arrow
        else if (e.keyCode === 40) {
          if (activeSuggestionIndex - 1 === filteredSuggestions.length) {
            return;
          }

          setActiveSuggestionIndex(activeSuggestionIndex + 1);
        }
      };

      const SuggestionsListComponent = (props) => {
        return filteredSuggestions.length ? (
          <ul class="suggestions">
            {filteredSuggestions.map((suggestion, index) => {
              let className;

              // Flag the active suggestion with a class
              if (index === activeSuggestionIndex) {
                className = "suggestion-active";
              }

              return (
                <li className={className} key={suggestion} onClick={e=>onClick(e,props.index,props.targetValue)}>
                  {suggestion}
                </li>
              );
            })}
          </ul>
        ) : (
          <div class="no-suggestions">
            <span role="img" aria-label="tear emoji">
              😪
            </span>{" "}
            <em>sorry no suggestions</em>
          </div>
        );
      };

    if (loading)
    {
        return(
            
        <LoadingScreen/>
        )
    }

 
    return (

 
        <div className='entirePage'>
            {console.log(userEmail)}
            <Helmet>
            <title>Transit Pro | Home</title>
            </Helmet>
            <Navbar/>
            <div id="row" >
            <div className="column-landing  col-left">
                {console.log("Line No 485",posts)}
            <div className="miniProfile">
            {
                Object.keys(posts).length!==0?
                <h2>{posts.Company}</h2>
               :
                <h2>Company pvt. Ltd.</h2>
            }

             
            <NavLink exact to="/profile" className="prof-link">View Profile</NavLink>
            <div id="prof-data">
               <h6>Profile Completion</h6>
                <ProfileProgress key={percentage} done={percentage} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>
            <div id="prof-data">
               <h6>Competitive Rate</h6>
              <ProfileProgress key={0} done={0} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>
            <div id="prof-data">
               <h6>Market Presence</h6>
              <ProfileProgress key={0} done={0} progress="progressmini" progressDone="progress-donemini" disp="none" />
            </div>

           <div className="member">
           <h5><b>Membership:</b> <span id='platinumMem' style={{color:'rgb(255, 99, 71)'}}>Premium</span></h5>
           {console.log(diffInDays>180)}
           <h6><strong>Validity</strong>:<span id="180validation">{180-diffInDays} Days</span></h6>
           </div>

         </div>
            <div className='rfqslive'>
                 <div className='Rfqs-ap'>
                    <p>RFQs applied</p>
                    <span style={{fontSize:'18px'}}>0</span>
                 </div>
                 <div className='Rfqs-pe'>
                    <p>Pending Decisions</p>
                    <span style={{fontSize:'18px'}}>0</span>
                 </div>
             </div>
             {/* <div className='fillRfq'>
                <h5>Fill first RFQ</h5>
             </div> */}
         
         </div>
        <Popup trigger={isOpenProgress} setTrigger={setIsOpenProgress} style="popup-inner1">
            <div className='popup-rfqs-parent'>
                <h5 className='progressReport'>Your Profile Completion Score is <strong style={{color:"red"}}>{percentage}%</strong></h5>
                <ProfileProgress key={percentage} done={percentage} progress="progress" progressDone="progress-done" disp="block"/>
                <h5 className='progressReport'>Kindly fill out following data to achieve <strong style={{color:"green"}}>100%</strong> rating</h5>
                <Link className="bt-util" to="/otherdetails" style={{display:dispOther}}><span>Other-Details</span></Link>
                {/* <button className="bt-data" onClick={()=>(setIsopenKg(true),setIsOpenProgress(false))} style={{display:dispPerKg}}>Per Kg</button>
                <button className="bt-data"onClick={()=>(setIsopenTonne(true),setIsOpenProgress(false))} style={{display:dispPerTon}}>Per Tonne</button> */}
                <button className="bt-data"onClick={()=>(setIsopenLanes(true),setIsOpenProgress(false))} style={{display:dispPerFreq}}>Frequent Lanes</button>
            </div>
        </Popup>
         {/* middle Column */}
        <div className="column-landing col-mid">
            <div className="reqBox " id="req-div">
                <img src={truck} alt="icon" className="reqtruck"/>
                <input type="text" className="reqinp" placeholder="Post Requirements"/>
            </div>
            <div className="liverfq">
                <h3 style={{position:'relative',top:'-10px'}}> <span>LIVE</span> RFQs</h3>
                <div className="list-rfq">
                    <ul>
                        <li> Bid for Nagpur operations by <b>Marico Pvt Ltd.</b> :<span onClick={()=>setIsOpenRfqs(true)} style={{color:"#8b0000"}}>CLOSED</span></li>
                        <li> Bid for Bhiwandi Adhoc Lanes by <b>Exide Industries</b> :<span onClick={()=>setIsOpenRfqs(true)} style={{color:"#8b0000"}}>CLOSED</span></li>
                    </ul>
                    <Popup  trigger={isOpenRfqs} setTrigger={setIsOpenRfqs} style="popup-inner">
                        
                        <div className='RFQCLOSED'>
                            <h2 style={{borderBottom: '3px solid rgba(0, 0, 0, 0.15)'}}><strong>RFQ Closed</strong></h2>
                            <div className='RfqClosedPopup'>
                                <img src={image_32} alt="cross" style={{width:'50px'}}/>
                                <div>
                                    <h4>This RFQ has been closed</h4>
                                    <h6>Last Date was on 16/1/2022</h6>
                                </div>
                            </div>
                            <div className='RfqSymbolPopup'>
                                <img src={image_33} alt="symbol" style={{width:'50px'}}/>
                                <h4><strong>You will be notified whenever a new RFQ is floated</strong></h4>
                            </div>
                            <button className='RfqPopupSub' /*onClick={()=>history.push('/TenderPage')}*/ >Sure</button>
                        </div>
                    </Popup>
                </div>
            </div>
            <div>
                <LiveRfqs/>
            </div>
         </div>


         {/* Right col */}
         <div className="column-landing col-right ">
             {/* Util */}
             <div className="util">
                 <h3>My Utilities</h3>
                <Link className="bt-util" to="/RFQ"><span>RFQs</span></Link>
                 
                <Link className="bt-util" to="/Analytics"><span>My Analytics</span></Link>
                 
                <Link className="bt-util" to="/Quotations"><span>My Quotations</span></Link>
             </div>

             {/* Data */}
             <div className="data">
             <h3>My Data</h3>
             {/* <button className="bt-data" onClick={()=>setIsopenKg(true)}>Per Kg</button>


             <Popup trigger={isOpenKg} setTrigger={setIsopenKg}>
               <h2>My Data Per Kg</h2>
               <form className="pop-form" onSubmit={formHandlerKg}>
                   <div id="row-pop">
            <a id="upl-btn" href="https://firebasestorage.googleapis.com/v0/b/transit-pro-fdf25.appspot.com/o/files%2FTransit%20template%2FTransit%20TemplateKg.xlsx?alt=media&token=fa2f1606-6ede-49d9-b585-23f3647486a8">Download Template</a>
                   <div id="row-pop-inner"><GoArrowRight className="ico-pop"/>
                
                     <input type="file" id="file-inp-kg" />
                 <GoArrowRight className="ico-pop"/>
                 </div>
                    <button type="submit" id="upl-btn" >Upload</button>
                    </div>
                </form>
                    <p style={{display: uploadPc}}>Uploading...</p>
                  
                <div style={{display:dispPerKgLast}} >
                    <h5>Last Uploaded File</h5>
                    <button onClick={(e)=>{fetchFilesKg();
                    e.preventDefault();
                    
                    } }className="sub-btn btn-rfrsh" type="button"><GrRefresh/></button>
                        
                  
                  
                </div>

                          
               
             </Popup>
             
                 
                 <button className="bt-data"onClick={()=>setIsopenTonne(true)}>Per Tonne</button>

                 <Popup trigger={isOpenTonne} setTrigger={setIsopenTonne}>
                     <h2>My Data Per Tonne</h2>
                     <form className="pop-form" onSubmit={formHandlerTonne}>
                   <div id="row-pop">
            <a id="upl-btn" href="https://firebasestorage.googleapis.com/v0/b/transit-pro-fdf25.appspot.com/o/files%2FAdmin_Transit_Templates%2FPer%20tonne%20Data.xlsx?alt=media&token=f9a85c94-6f0e-407d-bb6d-3ee6136f9e2d">Download Template</a>
                   <div id="row-pop"><GoArrowRight className="ico-pop"/>
                 <input type="file" id="file-inp-tonne" style={{display:"block"}}/>
                 <GoArrowRight className="ico-pop"/>
                 </div>
                    <button type="submit" id="upl-btn" >Upload</button>
                    </div>
                </form>
                    <p style={{display: uploadPc}}>Uploading...</p>
                  
         
                <div style={{display:dispPerTonLast}}>
                    <h5>Last Uploaded File</h5>
                    <button  onClick={(e)=>{fetchFilesTonne();
                    e.preventDefault();
                    } }className="sub-btn btn-rfrsh" type="button"><GrRefresh/></button>
                  
                </div>
                        
                          
             </Popup> */}


             {/* Lanes  */}
                 
                 <button className="bt-data"onClick={()=>setIsopenLanes(true)}>Frequent Lanes</button>
                 <Popup trigger={isOpenLanes} setTrigger={setIsopenLanes}>
                     <h3><strong>Frequent Lanes</strong></h3>
                      <p><strong>Fill out lanes where your vehicles travel the regularly :</strong></p>
                      {console.log(frequentLanes)}
                <div className="favouriteLanesExcelPart">
                  {frequentLanes.map((input,index)=>{
                  return(
                    <div key={index} className="favouriteLanesData">
                        <div>
                            <label id="companyNameLabel">From<span style={{color:"red"}}>*</span></label>
                  <input
                    suggestions={data}
                    type="text"
                    id="From"
                    name="from"
                    className="inputCompany"
                    onKeyDown={e=>onKeyDownFrom(e,index)}
                    placeholder="From"
                    value={input.from}
                    onChange={event =>{onChangeFrom(event,index)}}
                    
                  />
                    {showSuggestionsF[index] && input && <SuggestionsListComponent index={index} targetValue="from"/>}
                  </div>
                  <div>
                <label id="companyNameLabel">To<span style={{color:"red"}}>*</span></label>
                <input
                    suggestions={data}
                    type="text"
                    id="To"
                    name="to"
                    className="inputCompany"
                    onKeyDown={e=>onKeyDownTo(e,index)}
                    placeholder="To"
                    value={input.to}
                    onChange={event =>{onChangeTo(event,index)}}
                    required
                  />
                    {showSuggestionsT[index] && input && <SuggestionsListComponent index={index} targetValue="to"/>}
                  </div>
                  <div>
                <label id="companyNameLabel">Type</label>
                  <select
                  id="ServiceType"
                  name="type"
                  className="inputCompany"
                  defaultValue={input.type}
                  required
                  onChange={event => handleFormChange(index, event)}>
                      <option value="">-Service Type-</option>
                      <option value="FTL">FTL</option>
                      <option value="PTL">PTL</option>
                      <option value="Both">Both</option>
                  </select>
                  </div>
                    <div className='addMinusFreq'>
                    <div className="addFieldFavLanes" onClick={addInput}>+</div>
                    <div className='addFieldFavLanes' style={checkFreqTable()} onClick={()=>minusInput(index)}>-</div>
                    </div>
                  </div>
                  )
                  })}
                </div>  
                
                <div className="FavouriteLanesSubmitDiv">
                    {/* <div className="LastUpload">
                    <div className="LabelOfLastUpload"><h6>Last Uploaded File</h6></div>
                    <button onClick={(e)=>{fetchFilesLanes();
                    e.preventDefault();
                    } }className="button-refresh" type="button"><GrRefresh/></button>
                </div> */}
                <button onClick={fileHandlerLanes} className="submitButtonFavLanes">Submit</button>
                </div>        
               
             </Popup>
             </div>
         </div>
     </div>
     <Footer/>
        <Snackbar
            anchorOrigin={{ vertical:'bottom', horizontal:'left' }}
            open={openSnackBar}
            autoHideDuration={8000}
            onClose={handleClose}
            >
            <Alert onClose={handleClose} severity={severity}>
                {msg}
            </Alert>
          </Snackbar>
     </div>
    )
}

export default LandingPage
